exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".typography__title___3_Cn4 {\n  font: normal normal 400 40px/64px 'Shadows Into Light Two', cursive;\n}\n\n.typography__subTitle___2H18S {\n  font: normal normal 400 30px/48px 'Shadows Into Light Two', cursive;\n}\n\n.typography__header___EvFGN {\n  font: normal normal 400 24px/32px 'Raleway', sans-serif;\n}\n\n.typography__strong___gP51q {\n  font: normal normal 600 16px/22px 'Raleway', sans-serif;\n}\n\n.typography__link___2ts6m {\n  cursor: pointer;\n  text-decoration: none;\n  border-bottom: 1px solid #8c9fed;\n  color: #8c9fed;\n}\n\n.typography__link___2ts6m:hover {\n  color: #2f52e0;\n  border-bottom-color: #2f52e0;\n}\n\n.typography__paragraph___1lyoK {\n  font: normal normal 400 16px/20px 'Raleway', sans-serif;\n}\n\n.typography__paragraph___1lyoK + .typography__paragraph___1lyoK {\n  margin-top: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"title": "typography__title___3_Cn4",
	"subTitle": "typography__subTitle___2H18S",
	"header": "typography__header___EvFGN",
	"strong": "typography__strong___gP51q",
	"link": "typography__link___2ts6m",
	"paragraph": "typography__paragraph___1lyoK"
};